var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcDownload = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "downloadik",
    x: 0,
    y: 0,
    width: 345,
    height: 1491
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.4%",
    y: "-0.3%",
    width: "102.9%",
    height: "100.7%",
    filterUnits: "objectBoundingBox",
    id: "downloadik4"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.2 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 0.5,
    operator: "erode",
    in: "SourceAlpha",
    result: "shadowSpreadOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 2,
    in: "shadowSpreadOuter2",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.12 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter3"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    in: "shadowOffsetOuter3",
    result: "shadowBlurOuter3"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.14 0",
    type: "matrix",
    in: "shadowBlurOuter3",
    result: "shadowMatrixOuter3"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter3"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M10.2666667,3.66666667 C9.86186667,3.66666667 9.53333333,3.9952 9.53333333,4.4 L9.53333333,10.2666667 L6.6,10.2666667 L11,14.6666667 L15.4,10.2666667 L12.4666667,10.2666667 L12.4666667,4.4 C12.4666667,3.9952 12.1381333,3.66666667 11.7333333,3.66666667 L10.2666667,3.66666667 Z M3.66666667,16.8666667 L3.66666667,18.3333333 L18.3333333,18.3333333 L18.3333333,16.8666667 L3.66666667,16.8666667 Z",
    id: "downloadik3"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "downloadik2",
    x: 0,
    y: 0,
    width: 45.8333333,
    height: 45.8333333
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "downloadik5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "downloadik6",
    transform: "translate(-316.000000, -342.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "downloadik11",
    stroke: "#DFE2E5",
    fill: "#F7F8FA",
    x: -0.5,
    y: 208.5,
    width: 376,
    height: 1547
  }), /*#__PURE__*/React.createElement("g", {
    id: "downloadik10",
    transform: "translate(15.000000, 224.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "downloadik9"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#downloadik4)",
    xlinkHref: "#downloadik"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFFFFF",
    fillRule: "evenodd",
    xlinkHref: "#downloadik"
  })), /*#__PURE__*/React.createElement("g", {
    id: "downloadik6-13",
    transform: "translate(20.000000, 110.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "downloadik15",
    transform: "translate(273.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,4.0042577 C0,1.79276724 1.78902751,0 4.0042577,0 L27.9957423,0 C30.2072328,0 32,1.78902751 32,4.0042577 L32,27.9957423 C32,30.2072328 30.2109725,32 27.9957423,32 L4.0042577,32 C1.79276724,32 0,30.2109725 0,27.9957423 L0,4.0042577 Z",
    id: "downloadik16",
    fill: "#1890FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "downloadik14",
    transform: "translate(5.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "downloadik13",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#downloadik3"
  })), /*#__PURE__*/React.createElement("use", {
    id: "downloadik9",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#downloadik3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "downloadik6",
    mask: "url(#downloadik13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11.916667, -11.916667)",
    id: "downloadik8"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "downloadik7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#downloadik2"
  })), /*#__PURE__*/React.createElement("use", {
    id: "downloadik12",
    fill: "#FFFFFF",
    xlinkHref: "#downloadik2"
  })))))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcDownload, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-download.0212a6ca.svg";
export { ForwardRef as ReactComponent };